import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import DeleteAccount from "./pages/DeleteAccount"; // ✅ nova importação
import Header from "./components/Header";
import Footer from "./components/Footer";
import About from "./pages/About"; // ⬅️ adicione isso
import Unsubscribe from "./pages/Unsubscribe"; // ✅ Adicione esta importação
import Contact from "./pages/Contact";
import WhiteLabel from "./pages/WhiteLabel";
import Download from "./pages/Download";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}

function AppLayout() {
  const { pathname } = useLocation();
  const isDownloadPage = pathname === "/download";

  return (
    <>
      <ScrollToTop />
      {!isDownloadPage && <Header />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/termo-de-uso" element={<Terms />} />
        <Route path="/politica-de-privacidade" element={<Privacy />} />
        <Route path="/delete-account" element={<DeleteAccount />} /> {/* ✅ nova rota */}
        <Route path="/about" element={<About />} /> {/* ⬅️ nova rota */}
        <Route path="/unsubscribe" element={<Unsubscribe />} /> {/* ⬅️ nova rota */}
        <Route path="/contato" element={<Contact />} />
        <Route path="/white-label" element={<WhiteLabel />} />
        <Route path="/download" element={<Download />} />
      </Routes>
      {!isDownloadPage && <Footer />}
    </>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
